<template>
  <div class="body">
    <div class="title">
      入园审批
      <!-- 面包屑导航区域 -->
      <div class="fansk">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/countyApproval' }"
            ><span class="dsadf"> 学校审批 </span></el-breadcrumb-item
          >
          <el-breadcrumb-item>入园审批</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="btnsearch">
      <div class="left"></div>
      <div class="right">
        <el-form :inline="true">
          <el-form-item>
            <el-select
              placeholder="审批状态筛选"
              v-model="query.status"
              style="min-width: 168px; width: 168px"
              @change="Discountsearch"
            >
              <el-option
                v-for="item in optionStatus"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input
              style="width: 320px"
              clearable
              v-model="query.title"
              placeholder="通过姓名或者身份证模糊搜索"
            >
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="Discountsearch">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <vxe-table
      :data="applyList"
      border
      stripe
      resizable
      max-height="750"
      class="mytable-scrollbar"
      show-overflow
      keep-source
      align="center"
      :highlight-current-column="true"
    >
      <vxe-table-column field="id" title="ID" min-width="50">
      </vxe-table-column>
      <vxe-table-column field="realname" title="姓名" min-width="100">
      </vxe-table-column>
      <vxe-table-column field="idcard" title="身份证号" min-width="200">
      </vxe-table-column>
      <vxe-table-column field="contacts" title="紧急联系人及方式" min-width="200">
        <template slot-scope="scope">
          {{ scope.row.contacts }}({{ scope.row.contact_phone}})
        </template>
      </vxe-table-column>
      <vxe-table-column field="head_image" title="头像" min-width="80">
        <template slot-scope="scope">
          <el-image
            style="height: 100px"
            fit="cover"
            :src="scope.row.head_image"
            :preview-src-list="[scope.row.head_image]"
          >
          </el-image>
        </template>
      </vxe-table-column>
      <vxe-table-column field="sort" title="申请时间" min-width="220">
        <template slot-scope="scope">{{ scope.row.applytime_frmt }}</template>
      </vxe-table-column>
      <vxe-table-column title="状态 " min-width="80">
        <template slot-scope="scope">
          <el-tag type="warning" v-if="scope.row.status == 1"> 待审批 </el-tag>
          <el-tag type="success" v-if="scope.row.status == 2"> 通过 </el-tag>
          <el-tag type="danger" v-if="scope.row.status == 3"> 不通过 </el-tag>
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" width="240" fixed="right" v-if="query.status != 4">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.status == 1"
            type="primary"
            size="mini"
            @click="handleApplicationApplroved(scope.row)"
          >
            申请通过
          </el-button>
          <el-button
            v-if="scope.row.status == 1"
            type="danger"
            size="mini"
            @click="handleApplicationNotApplroved(scope.row)"
            icon="el-icon-edit"
          >
            申请不通过
          </el-button>
        </template>
      </vxe-table-column>
    </vxe-table>
    <div v-if="pageshow">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="cur_page"
        :page-sizes="[10]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>

    <el-dialog
      title="审批驳回原因"
      :visible.sync="dialogVisibleByNotApplroved"
      width="450px"
      append-to-body
    >
      <div style="margin-bottom: 12px; font-size: 16px">
        不通过「{{ currentApplrovel.realname }}({{
          currentApplrovel.idcard
        }})」的申请，请填写原因
      </div>
      <el-input
        type="textarea"
        :autosize="{ minRows: 4, maxRows: 6 }"
        placeholder="请输入审核不通过原因"
        v-model="currentApplrovel.remark"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleByNotApplroved = false">
          取 消
        </el-button>
        <el-button type="primary" @click="handleNotApplroved">
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getApplyList, applyOperate } from "@/api/school";
import dayjs from "dayjs";

export default {
  name: "index",
  data() {
    return {
      dialogVisibleByNotApplroved: false,
      currentApplrovel: {
        id: "",
        status: "",
        remark: "",
      },
      pageshow: true,
      total: null,
      query: {
        token: sessionStorage.getItem("token"),
        title: "",
        status: 1,
        page: 1,
        pagesize: 10,
      },
      applyList: [],
      token: sessionStorage.getItem("token"),
      optionStatus: [
        {
          value: 1,
          label: "待审批",
        },
        // {
        //   value: 2,
        //   label: "审批通过",
        // },
        // {
        //   value: 3,
        //   label: "审批驳回",
        // },
        {
          value: 4,
          label: "已审批",
        },
      ],
      cur_page: 1,
    };
  },
  created() {
    this.getApplyList();
  },
  methods: {
    handleApplicationApplroved(item) {
      console.log("_审核通过", item);
      this.currentApplrovel = item;

      this.$confirm(
        `确认「${item.realname}(${item.idcard})」审批通过, 是否继续?`,
        "审批通过",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          beforeClose: async (action, instance, done) => {
            console.log("_action", action);
            if (action === "cancel") return done();
            if (action === "confirm") {
              const resp = await applyOperate({
                id: this.currentApplrovel.id,
                status: "2",
                remark: "同意",
              });
              console.log("_调试完成审批通过", resp);
              setTimeout(() => {
                this.getApplyList();
                done();
              }, 700);
            }
          },
        }
      ).catch(() => {});
    },
    handleApplicationNotApplroved(item) {
      console.log("_审核不通过", item);
      this.currentApplrovel = item;
      this.$nextTick(() => {
        this.dialogVisibleByNotApplroved = true;
      });
    },
    async handleNotApplroved() {
      console.log("_notapplroved", this.currentApplrovel);
      const resp = await applyOperate({
        id: this.currentApplrovel.id,
        status: "3",
        remark: this.currentApplrovel.remark,
      });
      console.log("_handleNotApplroved", resp);

      this.dialogVisibleByNotApplroved = false;
      setTimeout(() => {
        this.getApplyList();
        this.currentApplrovel = {};
      }, 700);
    },

    Discountsearch() {
      this.cur_page = 1;
      this.getApplyList();
      this.pageshow = false; // 让分页隐藏
      this.$nextTick(() => {
        // 重新渲染分页
        this.pageshow = true;
      });
    },
    getApplyList() {
      getApplyList(this.query).then(({ data: res }) => {
        console.log("res", res);
        this.applyList = res.data.list.map((item) => {
          return {
            ...item,
            applytime_frmt: dayjs(new Date(item.applytime * 1000)).format("YYYY-MM-DD HH:mm:ss"),
          };
        });
        this.total = res.data.total - 0;
        console.log("_this.applyList", this.applyList);
      });
    },

    handleSizeChange(val) {
      this.query.pagesize = val;
      this.handleCurrentChange(this.query.page);
    },
    handleCurrentChange(val) {
      this.query.page = val;
      this.getApplyList();
    },
  },
};
</script>

<style scoped lang="less">
.imgs {
  width: 130px;
  height: 70px;
  background: rgba(0, 0, 0, 0);
  border-radius: 2px;
}
.body {
  display: flex;
  flex-direction: column;
  .title {
    opacity: 1;
    font-size: 30px;
    font-family: PingFang SC, PingFang SC-Heavy;
    font-weight: 800;
    text-align: left;
    color: #2e2e2e;
    letter-spacing: 0px;
    margin-bottom: 35px;
    display: flex;
    flex-direction: row;
    align-items: center;
    .fansk {
      margin-top: 30px;
      margin-left: 32px;
    }
    .dsadf {
      color: #3d9aff;
    }
  }
  .btnsearch {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    .left {
      margin-right: 150px;
    }
    .right {
      margin-top: 27px;
    }
  }
}
</style>
